import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faArrowRight, faBan, faCalendarAlt,faFlagCheckered, faCheck,faCopy, faClipboardCheck, faDollarSign, faEdit, faFilter, faInfo, faInfoCircle, faLock, faPercentage, faPlus, faPrint, faSave, faSync, faTimes, faTrashAlt, faCalculator } from '@fortawesome/free-solid-svg-icons';
import { PDFViewer } from '@react-pdf/renderer';
import PDF from './VerPdf';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        disabledEditarButton: false,
        disabledCongelarButton: false,
        disabledAnularButton: false,
        disabledDuplicarButton: false,
        disabledAprobarButton: false,
        estadoCotizacionBC: '',
        estadoCotizacionText: '',
        cotizaciones: [],
        departamentos: [],
        municipios: [],
        productos: [],productos2: [],
        equipos: [],
        ListaItem:[],
        productosCotizacion: [],
        equiposCotizacion: [],
        listaMateriales: [],
        errores: [],
        Periodos:[],
        TotalEqp:0,
        TotalMat:0,
        TotalTra:0,
        TotalMo:0,
        CostoIng:0,
        CostoAdm:0,
        CostoIns:0,
        CostoInt:0,
        CostoCer:0,
        CostoFin:0,
        TotalCosto:0,
        TotalIns:0,
        TotalSuministroUnd:0,
        IvaSuminstro:0,
        CantidadSuministro:0,
        IdItem:0,
        Producto:0,
        CargandoMat:0,
        TotalIva:0,
        TotalCot:0,
        Utilidad:0,
        GranTotal:0,
        InversionFinal:0,
        InversionInicial:0,
        TotalUtilidad:0,
        InversionFinal1:0,
        InversionInicial1:0,
        EstadoCot:1,Resolucion:0,BOTONES:0,
    }
    cambioValor = (e) => {
        const state = this.state.cotizaciones;
        state[e.target.name] = e.target.value;
        this.setState({ cotizaciones: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const ID_COD_DPTO = document.getElementById("ID_COD_DPTO").value;
        const ID_COD_MPIO = document.getElementById("ID_COD_MPIO").value;
        const TIPO_MONEDA = document.getElementById("TIPO_MONEDA").value;
        const inv_inicial = document.getElementById("inv_inicial").value;
        const inv_final = document.getElementById("inv_final").value;
        //const utilidad = document.getElementById("utilidad").value;
        const proyecto = document.getElementById("proyecto").value;
        const alcance = document.getElementById("alcance").value;
        const Resolucion = document.getElementById("RESOLUCION").value;
        const Periodo = document.getElementById("PERIODO").value;
        var errores = [];
        if (!ID_COD_DPTO) { errores.push("error_id_cod_dpto"); }
        if (!ID_COD_MPIO) { errores.push("error_id_cod_mpio"); }
        if (!TIPO_MONEDA) { errores.push("error_tipo_moneda"); }
        //if (!inv_inicial) { errores.push("error_inv_inicial"); }
       //if (!inv_final) { errores.push("error_inv_final"); }
        if (!Periodo) { errores.push("error_periodo"); }
        if (!proyecto) { errores.push("error_proyecto"); }
        if (!alcance) { errores.push("error_alcance"); }
        if (!Resolucion) { errores.push("error_tipo_resolucion"); }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(errores.length);
        Swal.showLoading();
        this.setState({ errores: errores });
        
        if (errores.length > 0) {
            return false;
        }
        authAxios.post("cotizaciones/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Cotizaciones!',
                    datosRespuesta.data.msj, 
                    'success'
                )
                //this.setState({ Utilidad: utilidad });
                //this.props.history.push("/MasterMateriales"); james
            })
            .catch(console.log)
    }
    enviarDatosUCAP = (e) => {
        e.preventDefault();
        const costo_ingenieria = document.getElementById("costo_ingenieria").value;
        const costo_admin_obra = document.getElementById("costo_admin_obra").value;
        const costo_inspector = document.getElementById("costo_inspector").value;
        const costo_interventoria = document.getElementById("costo_interventoria").value;
        const costo_certificado = document.getElementById("costo_certificado").value;
        const costo_financiero = document.getElementById("costo_financiero").value;
        var errores = [];
        if (!costo_ingenieria) { errores.push("error_costo_ingenieria"); }
        if (!costo_admin_obra) { errores.push("error_costo_admin_obra"); }
        if (!costo_inspector) { errores.push("error_costo_inspector"); }
        if (!costo_interventoria) { errores.push("error_costo_interventoria"); }
        if (!costo_certificado) { errores.push("error_costo_certificado"); }
        if (!costo_financiero) { errores.push("error_costo_financiero"); }
        let form = document.getElementById('formUCAP');
        let formData = new FormData(form);
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        Swal.showLoading();
        authAxios.post("cotizaciones/actualizarporcentaje", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Cotizaciones - UCAP!',
                    datosRespuesta.data.msj,
                    'success'
                )
            })
            .catch(console.log)
    }
    cargarMunicipios(id_cod_dpto, id_cod_mpio) {
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_cod_dpto)
            .then((datosRespuesta) => {
                console.log('municipios....');
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipios: datosRespuesta.data, load: '' });
                document.getElementById("ID_COD_MPIO").value = id_cod_mpio;
                window.$("#ID_COD_MPIO").focus();
                Swal.close();
            })
            .catch(console.log);
    }
    PeriodosIpp() {
        Swal.showLoading();
        authAxios.get("ipp/index_select")
            .then((datosRespuesta) => {
                console.log('Periodos....');
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, Periodos: datosRespuesta.data, load: '' });
            })
            .catch(console.log);
    }
    buscarMunicipios() {
        Swal.showLoading();
        var id_cod_dpto = document.getElementById("ID_COD_DPTO").value;
        this.cargarMunicipios(id_cod_dpto, '');
    }
    CargarModelo(){
        const DPTO = document.getElementById("ID_COD_DPTO").value;
        const MPIO = document.getElementById("ID_COD_MPIO").value;
        Swal.showLoading();
        var datosEnviar = {
            departamento: DPTO,
            cot: this.props.match.params.id,
            municipio: MPIO
        }

        Swal.fire({
            title: 'Estas seguro de copiar todo el modelo?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Copiar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.post("cotizaciones/copiar_modelo/",datosEnviar)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        //Swal.fire('Actualizado!', datosRespuesta.data.msj, 'success')
                        alert(datosRespuesta.data.msj);
                       // this.props.history.push("/UpCotizaciones/" + id_cotizacion);
                        window.location.href = '/UpCotizaciones/' + this.props.match.params.id;
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })

    }
    // carga el listado de producto a seleccionar
    cargarProductos(page) {
        Swal.showLoading();
        let cod = document.getElementById('bcodigoProducto').value;
        let cat = document.getElementById('bnombrecat').value;
        let bname = document.getElementById('bnombreProducto').value;
        let bmun = document.getElementById('bnombremunicipio').value;
        let global = document.getElementById('global').value;
        if (bmun == '') {
            this.setState({BOTONES: 0 });
        }else{
            this.setState({BOTONES: 1 });
        }
        var datos = {nombre:bname, municipio:bmun, codigo:cod, categoria:cat,global:global}
        authAxios.post("productos/index_new?page=" + page, datos)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    load: '',
                    productos: datosRespuesta.data.data,
                    paginaProductos: datosRespuesta.data.total,
                    ultimoProductos: datosRespuesta.data.last_page,
                    actualProductos: datosRespuesta.data.current_page
                });
                Swal.close();
            })
            .catch(console.log);
    }
    AgregarMasivoMunicipio(){
        Swal.showLoading();
        let bname = document.getElementById('bnombreProducto').value;
        
        if (bname == '') {
            bname = 0;
        }
        let bmun = document.getElementById('bnombremunicipio').value;
        
        if (bmun == '') {
            alert("Debes de buscar un municipio para agregarlo a la cotizacion.");
            return false;
            bmun = 0;
        }
        var datosEnviar = this.props.match.params.id;
        authAxios.get("cotizaciones/agregarmasivomunicipio/"+bmun+"/"+datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                
                Swal.close();
            })
            .catch(console.log);
    }
    //cargar productos con historial de cotizacion
    cargarProductos2(page) {
        Swal.showLoading();
        let bname = document.getElementById('bnombreProducto2').value;
        const DPTO = document.getElementById("ID_COD_DPTO").value;
        const MPIO = document.getElementById("ID_COD_MPIO").value;
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("productos/index_relacionado/" + bname + "/"+DPTO+"/"+MPIO+"?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    load: '',
                    productos2: datosRespuesta.data.data,
                    paginaProductos2: datosRespuesta.data.total,
                    ultimoProductos2: datosRespuesta.data.last_page,
                    actualProductos2: datosRespuesta.data.current_page
                });
                Swal.close();
            })
            .catch(console.log);
    }
 
    agregarProducto = (id_tabla) => {
        var cantidadEquipo = document.getElementById("cantidadProducto_" + id_tabla).value;
        var tipo = document.getElementById("tipo_" + id_tabla).value;
    
        var datosEnviar = {
            cantidad: cantidadEquipo,
            cot: this.props.match.params.id,
            producto: id_tabla,
            valor_moneda: window.localStorage.getItem("valorDolar"),
            tipo:tipo,
            id_usuario: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("cotizaciones/agregar_item",datosEnviar)
            .then((datosRespuesta) => {
               
                document.getElementById("cantidadProducto_" + id_tabla).value = "";
                Swal.close();
                Swal.fire(
                    'Cotizaciones - Items!',
                    datosRespuesta.data.msj,
                    datosRespuesta.data.icono=='success'?'success':'warning'
                )
                this.MostrarProducto(this.props.match.params.id);
            })
            .catch(console.log);
     
    }
    MostrarProducto = (id_tabla) => {

        Swal.showLoading();
        authAxios.get("cotizaciones/ver_item/"+id_tabla)
            .then((datosRespuesta) => {
                console.log(datosRespuesta.data);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ CargandoMat:1,InversionInicial1:datosRespuesta.data.inversion_inicial,InversionFinal1:datosRespuesta.data.inversion_final,TotalUtilidad:datosRespuesta.data.utilidad_neta,ListaItem: datosRespuesta.data.items, TotalIva: datosRespuesta.data.iva,TotalCot:datosRespuesta.data.total,GranTotal:datosRespuesta.data.gran_total});
                Swal.close();
                
            })
            .catch(console.log);
     
    }

    cambiarEstadoCot = (id_cotizacion, id_estado_cotizacion) => {
        var title;
        var buttonText;
        switch (id_estado_cotizacion) {
            case 2:
                title = 'Está seguro de Congelar la Cotización?';
                buttonText = 'Congelar';
                break;
            case 3:
                title = 'Está seguro de Anular la Cotización?';
                buttonText = 'Anular';
                break;
            case 4:
                title = 'Está seguro de Aprobar la Cotización?';
                buttonText = 'Aprobar';
                break;
            case 5:
                title = 'Está seguro de Duplicar la Cotización?';
                buttonText = 'Duplicar';
                break;
        }
        console.log(title);
        Swal.fire({
            title: title,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: buttonText,
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("cotizaciones/actualizarestado/" + id_cotizacion + "/" + id_estado_cotizacion)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        //Swal.fire('Actualizado!', datosRespuesta.data.msj, 'success')
                        alert(datosRespuesta.data.msj);
                       // this.props.history.push("/UpCotizaciones/" + id_cotizacion);
                        window.location.href = '/UpCotizaciones/' + id_cotizacion;
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    }
    //carga el APU del items del producto
    cargarDetalleProducto = (id_producto,cot,cantidad,id) => {
        this.setState({ listaMateriales: [] });
        Swal.showLoading();
        authAxios.get("cotizaciones/ver_materiales/" + id_producto+'/'+cot+'/'+cantidad)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var d = datosRespuesta.data;
                this.setState({  Producto:id_producto,IdItem:id, listaMateriales: d.Materiales, TotalEqp: d.TotalEqp, TotalMat: d.TotalMat, TotalTra: d.TotalTra, TotalMo: d.TotalMo,TotalCosto: d.Total,CostoIng:d.CostoIng,CostoAdm:d.CostoAdm,CostoIns:d.CostoIns,CostoInt:d.CostoInt,CostoCer:d.CostoCer,CostoFin:d.CostoFin,TotalSuministroUnd:d.TotalSuministroUnd,IvaSuminstro:d.Iva,CantidadSuministro:cantidad });
                Swal.close();
            })
            .catch(console.log);
    }
    EditarItem = (id) => {
        var cant = document.getElementById("up_cantidad").value;
        if(cant==0){
            Swal.fire(
                'Cotizaciones - Items!',
                'Debes de digitar una cantidad',
                'warning'
            )
            return false;
        }
        
    
         Swal.showLoading();
         const datos = {id:id,cot:this.props.match.params.id,cantidad:cant,producto:this.Producto, id_usuario: window.localStorage.getItem('idusuario')}
        authAxios.post("cotizaciones/editar_item", datos)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var d = datosRespuesta.data;
                Swal.fire(
                    'Editar - Items!',
                     d.msj,
                    'success'
                )
                this.MostrarProducto(this.props.match.params.id);
               // Swal.close();
            })
            .catch(console.log); 
    }
    Recalcular = () => {
   
        
         Swal.showLoading();
        const datos = {cot:this.props.match.params.id, id_usuario: window.localStorage.getItem('idusuario')}
        authAxios.post("cotizaciones/recalcular", datos)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var d = datosRespuesta.data;
                Swal.fire(
                    'Cotizacion!',
                     d.msj,
                    'success'
                )
                this.MostrarProducto(this.props.match.params.id);
               // Swal.close();
            })
            .catch(console.log); 
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el registro?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("cotizaciones/borrar_item/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.MostrarProducto(this.props.match.params.id);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    ImprimirRegistros = (id) => {
        Swal.fire('En construccion!', '...:(', 'success')
    }
    componentDidMount() {
        Swal.showLoading();
        this.PeriodosIpp();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentos: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("cotizaciones/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log('datos de la cotizacion'+datosRespuesta.data.inversioninicial);
                console.log(datosRespuesta);
                
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ EstadoCot:datosRespuesta.data.ESTADO_COTIZACION, InversionInicial: datosRespuesta.data.inversioninicial, InversionFinal: datosRespuesta.data.inversionfinal, Utilidad:datosRespuesta.data.UTILIDAD,datosCargados: true, cotizaciones: datosRespuesta.data, load: '',PorcIng:datosRespuesta.data.COSTO_INGENIERIA,PorcAdm:datosRespuesta.data.COSTO_ADMIN_OBRA,PorcIns:datosRespuesta.data.COSTO_INSPECTOR,PorcInt:datosRespuesta.data.COSTO_INTERVENTORIA,PorcCer:datosRespuesta.data.COSTO_CERTIFICADO,PorcFin:datosRespuesta.data.COSTO_FINANCIERO,Resolucion:datosRespuesta.data.RESOLUCION });
                var id_cod_dpto = datosRespuesta.data.ID_DEPARTAMENTO;
                var id_cod_mpio = datosRespuesta.data.ID_MUNICIPIO;
                document.getElementById("PERIODO").value = datosRespuesta.data.PERIODO;
                document.getElementById("ID_COD_DPTO").value = id_cod_dpto;
                switch (datosRespuesta.data.ESTADO_COTIZACION) {
                    case 1:
                        this.setState({ disabledEditarButton: false, disabledAnularButton: false, disabledCongelarButton: false, disabledDuplicarButton: false, disabledAprobarButton: true, estadoCotizacionBC: '#0D6EFD', estadoCotizacionText: 'EN PROCESO' })
                        break;
                    case 2:
                        this.setState({ disabledEditarButton: true, disabledAnularButton: false, disabledCongelarButton: true, disabledDuplicarButton: false, disabledAprobarButton: false, estadoCotizacionBC: '#0DCAF0', estadoCotizacionText: 'CONGELADO' })
                        break;
                    case 3:
                        this.setState({ disabledEditarButton: true, disabledAnularButton: true, disabledCongelarButton: true, disabledDuplicarButton: false, disabledAprobarButton: true, estadoCotizacionBC: '#DC3545', estadoCotizacionText: 'ANULADO' })
                        break;
                    case 4:
                        this.setState({ disabledEditarButton: true, disabledAnularButton: true, disabledCongelarButton: true, disabledDuplicarButton: true, disabledAprobarButton: true, estadoCotizacionBC: '#198754', estadoCotizacionText: 'APROBADO' })
                        break;
                }
                this.cargarMunicipios(id_cod_dpto, id_cod_mpio);
                this.MostrarProducto(this.props.match.params.id);
                
            })
            .catch(console.log);
        this.cargarProductos(1);
    }
    render() {
        const { load, cotizaciones, departamentos, municipios,TotalUtilidad,InversionFinal,InversionInicial,InversionInicial1,InversionFinal1,Periodos,
            productos,productos2, productosCotizacion, paginaProductos, ultimoProductos, actualProductos, paginaProductos2, ultimoProductos2, actualProductos2,Resolucion,BOTONES,
            listaMateriales,ListaItem,TotalEqp,TotalMat,TotalMo,TotalTra,EstadoCot ,CostoIng,CostoAdm,CostoIns,CostoInt,CostoFin,CostoCer,TotalCosto,TotalSuministroUnd,IvaSuminstro,CantidadSuministro,IdItem,Utilidad, CargandoMat,TotalIva,TotalCot,GranTotal} = this.state;
            
        return (
            <>
           
                <div className="content-wrapper">
                    <div className="content">
                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                <div className="card-header text-center">
                                    {load ? (<b>{load}</b>) : (<b>EDITAR COTIZACIÓN</b>)}
                                </div>
                                <div className="card-body">
                                    <div className='row'>
                                        <div className="col-xl-7">
                                            <div className="card">
                                                <div className="card-header text-center">
                                                    <b>INFORMACIÓN BÁSICA COTIZACIÓN</b>
                                                </div>
                                                <div className="card-body">
                                                    <form onSubmit={this.enviarDatos} id="form">
                                                        <div className='row'>
                                                            <div className="col-xl-12">
                                                                <div className='row g-3'>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="ID_COD_DPTO">Departamento</label>
                                                                        <input type="hidden" name="id" value={this.props.match.params.id} />
                                                                        <input type="hidden" name="id_cotizacion" value={cotizaciones.NO_COTIZACION} />
                                                                        <input type="hidden" name="id_version" value={cotizaciones.VERSION} />
                                                                        <input type="hidden" name="id_usuario" value={window.localStorage.getItem("idusuario")} />
                                                                        <select name="ID_COD_DPTO" id="ID_COD_DPTO"
                                                                            onChange={e => {
                                                                                this.buscarMunicipios(e);
                                                                                this.cambioValor(e)
                                                                            }}
                                                                            className={((this.verificarError("error_id_cod_dpto")) ? "is-invalid" : "") + " form-select form-select-sm"}>
                                                                            <option value="">Seleccione el Departamento</option>
                                                                            {
                                                                                departamentos.map((itemDepartamentos) => (
                                                                                    <option key={itemDepartamentos.ID_DEPARTAMENTO} value={itemDepartamentos.ID_DEPARTAMENTO}>{itemDepartamentos.NOMBRE}</option>
                                                                                ))
                                                                            }
                                                                        </select>
                                                                        <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="ID_COD_MPIO">Municipio</label>
                                                                        <select name="ID_COD_MPIO" id="ID_COD_MPIO"
                                                                            className={((this.verificarError("error_id_cod_mpio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                            onChange={this.cambioValor}>
                                                                            <option value="">Seleccione el Municipio</option>
                                                                            {
                                                                                municipios.map((item) => (
                                                                                    <option key={item.ID_MUNICIPIO} value={item.ID_MUNICIPIO}>{item.NOMBRE}</option>
                                                                                ))
                                                                            }
                                                                        </select>
                                                                        <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="ID_COD_MPIO">Periodo Referencia</label>
                                                                        <select name="PERIODO" id="PERIODO"
                                                                            className={((this.verificarError("error_periodo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                            onChange={this.cambioValor}>
                                                                            <option value="">Seleccione el Periodo</option>
                                                                            {
                                                                                Periodos.map((item) => (
                                                                                    <option key={item.id} value={item.id}>{item.name_select}</option>
                                                                                ))
                                                                            }
                                                                        </select>
                                                                        <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="RESOLUCION">Tipo Resolución</label>
                                                                        <select name="RESOLUCION"
                                                                            id="RESOLUCION"
                                                                            value={cotizaciones.RESOLUCION}
                                                                            options={cotizaciones.RESOLUCION}
                                                                            className={((this.verificarError("error_tipo_resolucion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                            onChange={this.cambioValor}>
                                                                            <option value="">Seleccione la resolucion</option>
                                                                        <option value="123">CREG 123</option>
                                                                    <option value="101">CREG 101</option>
                                                                        <option value="101H">HIST 101</option>
                                                                        <option value="123H">HIST 123</option>
                                                                        <option value="0">N/A</option>
                                                                        </select>
                                                                        <small id="helpId" className="invalid-feedback">Seleccione el Tipo resolucion</small>
                                                                    </div>
                                                                    
                                                                </div>
                                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="TIPO_MONEDA">Tipo Moneda</label>
                                                                        <select name="TIPO_MONEDA"
                                                                            id="TIPO_MONEDA"
                                                                            value={cotizaciones.TIPO_MONEDA}
                                                                            options={cotizaciones.TIPO_MONEDA}
                                                                            className={((this.verificarError("error_tipo_moneda")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                            onChange={this.cambioValor}>
                                                                            <option value="">Seleccione el Tipo Moneda</option>
                                                                            <option value="COL">En Pesos (COL)</option>
                                                                            <option value="USD">En Dolares (USD)</option>
                                                                            <option value="EUR">En Euro (EUR)</option>
                                                                        </select>
                                                                        <small id="helpId" className="invalid-feedback">Seleccione el Tipo Moneda</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="estado_cotizacion">Estado Cot.</label>
                                                                        <input type="hidden" id="id_estado_cotizacion" name="id_estado_cotizacion" value={cotizaciones.ESTADO_COTIZACION} />
                                                                        <input style={{ textTransform: 'uppercase', backgroundColor: this.state.estadoCotizacionBC, color: '#FFFFFF', fontWeight: 'bold' }} className={((this.verificarError("error_estado_cotizacion")) ? "is-invalid" : "") + " form-control form-control-sm text-center"} type="text" name="estado_cotizacion" id="estado_cotizacion" value={this.state.estadoCotizacionText} placeholder="Estado Cotización" aria-describedby="helpId" onChange={this.cambioValor} readOnly />
                                                                        <small id="helpId" className="invalid-feedback">Digite el Estado Cot.</small>
                                                                    </div>
                                                                    {/* <div className="col-md-3">
                                                                        <label htmlFor="inv_inicial">Utilidad</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="utilidad" id="utilidad" defaultValue={cotizaciones.UTILIDAD}
                                                                                className={((this.verificarError("error_utilidad")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Utilidad de la obra" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite la Utilidad de la obra</small>
                                                                    </div> */}
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="inv_inicial">Proyecto</label>
                                                                        <div className="input-group input-group-sm">
                                                                         
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="proyecto" id="proyecto" defaultValue={cotizaciones.PROYECTO}
                                                                                className={((this.verificarError("error_proyecto")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Nombre del proyecto" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite el nombre del proyecto</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="inv_inicial">Alcance</label>
                                                                        <div className="input-group input-group-sm">
                                                                           
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="alcance" id="alcance" defaultValue={cotizaciones.ALCANCE}
                                                                                className={((this.verificarError("error_utilidad")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Alcance del proyecto" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite el alcance</small>
                                                                    </div>
                                                                </div>
                                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="inv_inicial">Inversión Inicial</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                            <input type="text" name="inv_inicial" id="inv_inicial" value={InversionInicial1}
                                                                                className={((this.verificarError("error_inv_inicial")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Inversión Inicial" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite la Inversión Inicial</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="inv_final">Inversión Final</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="inv_final" id="inv_final" readOnly value={InversionFinal1}
                                                                                className={((this.verificarError("error_inv_final")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Inversión Final" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Digite la Inversión Final</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="fecha_ini">Fecha Inicial</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_ini" id="fecha_ini" defaultValue={cotizaciones.FECHA_INICIO}
                                                                                className={((this.verificarError("error_fecha_ini")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Inicial" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Inicial</small>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label htmlFor="fecha_fin">Fecha Final</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_fin" id="fecha_fin" defaultValue={cotizaciones.FECHA_FINAL}
                                                                                className={((this.verificarError("error_fecha_fin")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Final" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Final</small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div className='row'>
                                                            <div className='col-xl-12 text-center'>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button type="submit" disabled={this.state.disabledEditarButton === false ? '' : true} className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Cotización</button>&nbsp;&nbsp;
                                                                    <Link className="btn btn-danger btn-sm" to={"/MasterCotizaciones"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-5">
                                            <div className="card">
                                                <div className="card-header text-center">
                                                    <b>COTIZACIÓN # <span style={{ fontSize: 13 }} className="badge bg-secondary">{cotizaciones.NO_COTIZACION}</span> - VERSIÓN <span style={{ fontSize: 13 }} className="badge bg-secondary">{cotizaciones.VERSION}</span></b>
                                                </div>
                                                <div className="card-body">
                                                    {
                                                        cotizaciones.NO_COTIZACION !== '' ?
                                                            <div className="row text-center"> 
                                                                <div className="col-xl-12">
                                                                <div className='text-right btn-group btn-group-toggle'>
                                          <button style={{ color: '#FFFFFF' }} type="button" className="btn btn-info btn-sm mr-2" disabled={this.state.disabledCongelarButton === false ? '' : true} onClick={() => this.cambiarEstadoCot(this.props.match.params.id, 2)}>
                                                                        <FontAwesomeIcon icon={faLock} /> Congelar
                                                                    </button>
                                                                    <button type="button" className="btn btn-danger btn-sm mr-2" disabled={this.state.disabledAnularButton === false ? '' : true} onClick={() => this.cambiarEstadoCot(this.props.match.params.id, 3)}>
                                                                        <FontAwesomeIcon icon={faBan} /> Anular
                                                                    </button>
                                                                    
                                                                    <button type="button" className="btn btn-success btn-sm mr-2" disabled={this.state.disabledAprobarButton === false ? '' : true} onClick={() => this.cambiarEstadoCot(this.props.match.params.id, 4)}>
                                                                        <FontAwesomeIcon icon={faFlagCheckered} /> Aprobar
                                                                    </button>
                                                                    <button type="button" className="btn btn-secondary btn-sm  mr-2" disabled={this.state.disabledDuplicarButton === false ? '' : true} onClick={() => this.cambiarEstadoCot(this.props.match.params.id, 5)}>
                                                                        <FontAwesomeIcon icon={faCopy} />
                                                                    </button>
                                                                           <button type="button" className="btn btn-success btn-sm mr-2" data-bs-toggle='modal' data-bs-target="#UCAPModal">
                                                                                <FontAwesomeIcon icon={faPrint} /> 
                                                                            </button>
                                                                            <button type="button" className="btn btn-info btn-sm mr-2" data-bs-toggle='modal' data-bs-target="#PModal">
                                                                                
                                                                                <FontAwesomeIcon icon={faInfo} />
                                                                            </button>
                                        </div>
                                                                <form onSubmit={this.enviarDatosUCAP} id="formUCAP">
                                    <div className="row">
                                          
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                            <div className='col-md-6'>
                                                    <div className="col-md-12">
                                                        <label htmlFor="costo_ingenieria">Costo Ingeniería</label>
                                                        <input type="hidden" name="id" value={this.props.match.params.id} />
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="costo_ingenieria" id="costo_ingenieria" defaultValue={cotizaciones.COSTO_INGENIERIA}
                                                                className={((this.verificarError("error_costo_ingenieria")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Ingeniería" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                            <small id="helpId" className="invalid-feedback">Digite el Costo Ingeniería</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="costo_admin_obra">Costo Admin. Obra</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="costo_admin_obra" id="costo_admin_obra" defaultValue={cotizaciones.COSTO_ADMIN_OBRA}
                                                                className={((this.verificarError("error_costo_admin_obra")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Admin. Obra" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                            <small id="helpId" className="invalid-feedback">Digite el Costo Admin. Obra</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="costo_inspector">Costo Inspector</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="costo_inspector" id="costo_inspector" defaultValue={cotizaciones.COSTO_INSPECTOR}
                                                                className={((this.verificarError("error_costo_inspector")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Inspector" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                            <small id="helpId" className="invalid-feedback">Digite el Costo Inspector</small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className="col-md-12">
                                                        <label htmlFor="costo_interventoria">Costo Interventoría</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="costo_interventoria" id="costo_interventoria" defaultValue={cotizaciones.COSTO_INTERVENTORIA}
                                                                className={((this.verificarError("error_costo_interventoria")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Interventoría" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                            <small id="helpId" className="invalid-feedback">Digite el Costo Interventoría</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="costo_certificado">Costo Certificado</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="costo_certificado" id="costo_certificado" defaultValue={cotizaciones.COSTO_CERTIFICADO}
                                                                className={((this.verificarError("error_costo_certificado")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Certificado" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                            <small id="helpId" className="invalid-feedback">Digite el Costo Certificado</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="costo_financiero">Costo Financiero</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="costo_financiero" id="costo_financiero" defaultValue={cotizaciones.COSTO_FINANCIERO}
                                                                className={((this.verificarError("error_costo_financiero")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Financiero" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                            <small id="helpId" className="invalid-feedback">Digite el Costo Financiero</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm" disabled={this.state.disabledEditarButton === false ? '' : true}><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Guardar Parámetros</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                                                  
                                                                    
                                                                </div>
                                                            </div>
                                                            : null
                                                    }
                                                </div>
                                            </div>
                                           
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <hr />
                                        </div>
                                        <div className='col-xl-12'>
                                            <div className="card">
                                                <div className="card-header text-center">
                                                    <b>PRESUPUESTO UCAP</b>
                                                    <div className="mr-md-3">
                                                        {EstadoCot==1?
                                                         <><button type="button" className="btn btn-success btn-sm" data-bs-toggle='modal' data-bs-target="#PModal" slot='end'>
                                                                                <FontAwesomeIcon icon={faPlus} />  Productos
                                                                            </button>
                                                                         {/*    <button type="button" className="btn btn-success btn-sm" data-bs-toggle='modal' data-bs-target="#PModal2" slot='end'
                                                                            onClick={()=>this.cargarProductos2(1)}>
                                                                            <FontAwesomeIcon icon={faPlus} />  Historial de Productos 
                                                                        </button> */}
                                                                        <button type="button" className="btn btn-primary btn-sm" slot='end'
                                                                            onClick={()=>this.Recalcular()}>
                                                                            <FontAwesomeIcon icon={faCalculator} />  Recalcular 
                                                                        </button>
                                                                        </>
                                                                        :''}
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    
                                               
                                                    {
                                                        cotizaciones.NO_COTIZACION !== '' ?
                                                            <table className="table table-hover table-condensed table-sm">
                                                                <thead className="thead-inverse">
                                                                    <tr>
                                                                        <th className="align-middle">CÓDIGO</th>
                                                                        <th className="align-middle">PRODUCTO</th>
                                                                        <th className="align-middle">CANTIDAD</th>
                                                                        <th className="align-middle">PRECIO UND.</th>
                                                                        <th className="align-middle">IVA</th>
                                                                        <th className="align-middle">TOTAL</th>
                                                                        
                                                                        <th className="align-middle">OPCIONES</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        CargandoMat==1?
                                                                        ListaItem.map((item) => (
                                                                            <tr key={item.ID_DETALLE}>
                                                                                <td>{item.CODIGO}</td>
                                                                                <td>{item.NOMBRE}</td>
                                                                                <td>{item.CANTIDAD}</td>
                                                                                <td style={{textAlign: "right"}}><b>$ </b>{currencyFormat(item.VALOR_UNIDAD)}</td>
                                                                                <td style={{textAlign: "right"}}><b>$ </b>{currencyFormat(item.IVA_ADMIN*item.CANTIDAD)}</td>
                                                                                <td style={{textAlign: "right"}}><b>$ </b>{currencyFormat(item.TOTAL)}</td>
                                                                                <td>
                                                                                    <div className="btn-group" role="group" aria-label="">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-info btn-sm"
                                                                                            data-bs-toggle='modal'
                                                                                            data-bs-target="#ProductoModal"
                                                                                            onClick={() =>
                                                                                                this.cargarDetalleProducto(item.ID_PRODUCTO,item.ID_COTIZACION,item.CANTIDAD,item.ID_DETALLE)
                                                                                            }
                                                                                        >
                                                                                            <FontAwesomeIcon style={{ color: '#FFFFFF' }} icon={faInfoCircle} />
                                                                                        </button>&nbsp;&nbsp;
                                                                                        {EstadoCot==1?
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-danger btn-sm"
                                                                                            onClick={() =>
                                                                                                this.borrarRegistros(item.ID_DETALLE)
                                                                                            }
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                                                        </button>:''}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )):<tr>
                                                                            <td colSpan={7}>Cargando Registro....</td>
                                                                        </tr>
                                                                    }
                                                                </tbody>
                                                                <tr>
                                                                    <td colSpan={5}  style={{textAlign: "right"}}>Total Suministro:</td>
                                                                    <td  style={{textAlign: "right"}}>{currencyFormat(TotalCot)}</td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={5}  style={{textAlign: "right"}}>Costo Administracion:</td>
                                                                    <td  style={{textAlign: "right"}}>{currencyFormat(TotalUtilidad)}</td>
                                                                    <td></td>
                                                                </tr>
                                                                {/* <tr>
                                                                    <td colSpan={5}  style={{textAlign: "right"}}>Total Iva:</td>
                                                                    <td  style={{textAlign: "right"}}>{currencyFormat(TotalIva)}</td>
                                                                    <td></td>
                                                                </tr> */}
                                                                <tr>
                                                                    <td colSpan={5}  style={{textAlign: "right"}}>Total Obra:</td>
                                                                    <td  style={{textAlign: "right"}}><b>{currencyFormat(GranTotal)}</b></td>
                                                                    <td></td>
                                                                </tr>
                                                            </table>
                                                            : null
                                                    }
                                                </div>
                                               
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="ProductoModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ProductoModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="ProductoModalLabel">Detalle Producto</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card">
                                    <div className="card-header text-center">
                                        {load ? (<b>{load}</b>) : (<b>I. EQUIPO </b>)}
                                    </div>
                                    <div className="card-body">
                                        <div className='row'>
                                            <table className="table table-hover table-condensed table-sm">
                                                <thead className="thead-inverse">
                                                    <tr>
                                                        <th className="align-middle">CÓDIGO</th>
                                                        <th className="align-middle">DESCRIPCIÓN</th>
                                                        <th className="align-middle">UNIDAD</th>
                                                        <th className="align-middle">ULT UTILIDAD</th>
                                                        <th className="align-middle">CANTIDAD</th>
                                                        <th className="align-middle">RENDIMIENTO</th>
                                                        <th className="align-middle">VALOR UNIDAD</th>
                                                        <th className="align-middle">VALOR PARCIAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {load}
                                                    {
                                                        listaMateriales.map((itemListaMateriales) => (
                                                            itemListaMateriales.TIPO_MP=='EQP'?
                                                            <tr key={itemListaMateriales.ID_TABLA}>
                                                                <td>{itemListaMateriales.CODIGO_MP}</td>
                                                               
                                                                <td>{itemListaMateriales.NOMBRE}</td>
                                                                <td>{itemListaMateriales.TIPO_MP}</td>
                                                                <td>{itemListaMateriales.UTILIDAD} %</td>
                                                                <td>{itemListaMateriales.CANTIDAD_MP}</td>
                                                                <td>{currencyFormat(itemListaMateriales.RENDIMIENTO)}</td>
                                                                <td><b>$ </b>{currencyFormat(itemListaMateriales.VALOR_REAL)}</td>
                                                                <td><b>$ </b>{currencyFormat(((itemListaMateriales.VALOR_REAL * itemListaMateriales.CANTIDAD_MP)) * itemListaMateriales.RENDIMIENTO)}</td>
                                                            </tr>:''
                                                        ))
                                                    }
                                                </tbody>
                                                <tr>
                                                    <td colSpan={7} style={{textAlign: "right"}}>Total Equipo</td>
                                                    <td>${currencyFormat(TotalEqp)}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header text-center">
                                        {load ? (<b>{load}</b>) : (<b>II. SUMINISTRO Y/O MATERIALES </b>)}
                                    </div>
                                    <div className="card-body">
                                        <div className='row'>
                                            <table className="table table-hover table-condensed table-sm">
                                                <thead className="thead-inverse">
                                                    <tr>
                                                        <th className="align-middle">CÓDIGO</th>
                                                        <th className="align-middle">DESCRIPCIÓN</th>
                                                        <th className="align-middle">UNIDAD</th>
                                                        <th className="align-middle">ULT UTILIDAD</th>
                                                        <th className="align-middle">CANTIDAD</th>
                                                        <th className="align-middle">RENDIMIENTO</th>
                                                        <th className="align-middle">VALOR UNIDAD</th>
                                                        <th className="align-middle">VALOR PARCIAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                        listaMateriales.map((itemListaMateriales) => (
                                                            itemListaMateriales.TIPO_MP=='MAT'?
                                                            <tr key={itemListaMateriales.ID_TABLA}>
                                                                <td>{itemListaMateriales.CODIGO_MP}</td>
                                                                <td>{itemListaMateriales.NOMBRE}</td>
                                                                <td>{itemListaMateriales.TIPO_MP}</td>
                                                                <td>{itemListaMateriales.UTILIDAD} %</td>
                                                                <td>{itemListaMateriales.CANTIDAD_MP}</td>
                                                                <td>{currencyFormat(itemListaMateriales.RENDIMIENTO)}</td>
                                                                <td><b>$ </b>{currencyFormat(itemListaMateriales.VALOR_REAL)}</td>
                                                                <td><b>$ </b>{currencyFormat(((itemListaMateriales.VALOR_REAL * itemListaMateriales.CANTIDAD_MP)) * itemListaMateriales.RENDIMIENTO)}</td>
                                                            </tr>:''
                                                        ))
                                                    }
                                                </tbody>
                                                <tr>
                                                    <td colSpan={7} style={{textAlign: "right"}}>Total Materiales</td>
                                                    <td>${currencyFormat(TotalMat)}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header text-center">
                                        {load ? (<b>{load}</b>) : (<b>III. TRANSPORTES </b>)}
                                    </div>
                                    <div className="card-body">
                                        <div className='row'>
                                            <table className="table table-hover table-condensed table-sm">
                                                <thead className="thead-inverse">
                                                    <tr>
                                                        <th className="align-middle">CÓDIGO</th>
                                                        <th className="align-middle">DESCRIPCIÓN</th>
                                                        <th className="align-middle">UNIDAD</th>
                                                        <th className="align-middle">ULT UTILIDAD</th>
                                                        <th className="align-middle">CANTIDAD</th>
                                                        <th className="align-middle">RENDIMIENTO</th>
                                                        <th className="align-middle">VALOR UNIDAD</th>
                                                        <th className="align-middle">VALOR PARCIAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                        listaMateriales.map((itemListaMateriales) => (
                                                            itemListaMateriales.TIPO_MP=='TRA'?
                                                            <tr key={itemListaMateriales.ID_TABLA}>
                                                                <td>{itemListaMateriales.CODIGO_MP}</td>
                                                                <td>{itemListaMateriales.NOMBRE}</td>
                                                                <td>{itemListaMateriales.TIPO_MP}</td>
                                                                <td>{itemListaMateriales.UTILIDAD} %</td>
                                                                <td>{itemListaMateriales.CANTIDAD_MP}</td>
                                                                <td>{currencyFormat(itemListaMateriales.RENDIMIENTO)}</td>
                                                                <td><b>$ </b>{currencyFormat(itemListaMateriales.VALOR_REAL)}</td>
                                                                <td><b>$ </b>{currencyFormat(((itemListaMateriales.VALOR_REAL * itemListaMateriales.CANTIDAD_MP)) * itemListaMateriales.RENDIMIENTO)}</td>
                                                            </tr>:''
                                                        ))
                                                    }
                                                </tbody>
                                                <tr>
                                                    <td colSpan={7} style={{textAlign: "right"}}>Total Transporte</td>
                                                    <td>${currencyFormat(TotalTra)}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header text-center">
                                        {load ? (<b>{load}</b>) : (<b>IV. MANO DE OBRA </b>)}
                                    </div>
                                    <div className="card-body">
                                        <div className='row'>
                                            <table className="table table-hover table-condensed table-sm">
                                                <thead className="thead-inverse">
                                                    <tr>
                                                        <th className="align-middle">CÓDIGO</th>
                                                        <th className="align-middle">DESCRIPCIÓN</th>
                                                        <th className="align-middle">UNIDAD</th>
                                                        <th className="align-middle">ULT UTILIDAD</th>
                                                        <th className="align-middle">CANTIDAD</th>
                                                        <th className="align-middle">RENDIMIENTO</th>
                                                        <th className="align-middle">VALOR UNIDAD</th>
                                                        <th className="align-middle">VALOR PARCIAL</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                        listaMateriales.map((itemListaMateriales) => (
                                                            itemListaMateriales.TIPO_MP=='MO'?
                                                            <tr key={itemListaMateriales.ID_TABLA}>
                                                                <td>{itemListaMateriales.CODIGO_MP}</td>
                                                                <td>{itemListaMateriales.NOMBRE}</td>
                                                                <td>{itemListaMateriales.TIPO_MP}</td>
                                                                <td>{itemListaMateriales.UTILIDAD} %</td>
                                                                <td>{itemListaMateriales.CANTIDAD_MP}</td>
                                                                <td>{currencyFormat(itemListaMateriales.RENDIMIENTO)}</td>
                                                                <td><b>$ </b>{currencyFormat(itemListaMateriales.VALOR_REAL)}</td>
                                                                <td><b>$ </b>{currencyFormat(((itemListaMateriales.VALOR_REAL * itemListaMateriales.CANTIDAD_MP)) * itemListaMateriales.RENDIMIENTO)}</td>
                                                            </tr>:''
                                                        ))
                                                    }
                                                </tbody>
                                                <tr>
                                                    <td colSpan={7} style={{textAlign: "right"}}>Total Mano de Obra:</td>
                                                    <td>${currencyFormat(TotalMo)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}>Total Costos</td>
                                            
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Total:</td>
                                                    <td>{currencyFormat(TotalCosto)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Costo Ingeniería :</td>
                                                    <td>{currencyFormat(CostoIng)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Costo Admin. Obra:</td>
                                                    <td>{currencyFormat(CostoAdm)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Costo Inspector:</td>
                                                    <td>{currencyFormat(CostoIns)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Costo Interventoría:</td>
                                                    <td>{currencyFormat(CostoInt)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Costo Certificado:</td>
                                                    <td>{currencyFormat(CostoCer)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Costo Financiero:</td>
                                                    <td>{
                                                       currencyFormat( CostoFin)
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Total Unidad:</td>
                                                    <td>{
                                                    currencyFormat(TotalSuministroUnd)
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Iva Administrativo:</td>
                                                    <td>{
                                                      currencyFormat(CostoAdm * 0.19)
                                                    }</td>
                                                </tr>
                                                
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Total Unidad x Cantidad ({CantidadSuministro}): </td>
                                                    <td><b>{
                                                    currencyFormat(TotalSuministroUnd*CantidadSuministro)
                                                    }</b></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Total Iva :</td>
                                                    <td>{
                                                      currencyFormat((CostoAdm * 0.19)*CantidadSuministro)
                                                    }</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={7}  style={{textAlign: "right"}}>Total :</td>
                                                    <td>{
                                                      currencyFormat(((CostoAdm * 0.19)*CantidadSuministro) + (TotalSuministroUnd*CantidadSuministro))
                                                    }</td>
                                                </tr>
                                                {EstadoCot==1?
                                                <tr>
                                                     <td style={{textAlign: "right"}} colSpan={2}>Tipo de Inversion</td>
                                                     <td>
                                                        <select id="up_tipo" name="up_tipo" className='form-control form-control-sm form-select'>
                                                            <option value='CA'>Cantidad Actual</option>
                                                            <option value='CI'>Cantidad Para Inversion</option>
                                                        </select>
                                                    </td>
                                                    <td style={{textAlign: "right"}} colSpan={2}>Editar Cantidad:</td>
                                                    <td>
                                                        <input type="text" id="up_cantidad" name="up_cantidad" className='form-control form-control-sm' defaultValue={CantidadSuministro} />
                                                    </td>
                                                    <td>
                                                    <button
                                                                                            type="button"
                                                                                            className="btn btn-success btn-sm"
                                                                                            data-bs-dismiss="modal" aria-label="Close"
                                                                                            onClick={() =>
                                                                                                this.EditarItem(IdItem)
                                                                                            }
                                                                                        >Editar Cantidad</button>
                                                                                         <button
                                                                                            type="button"
                                                                                            className="btn btn-danger btn-sm"
                                                                                            onClick={() =>
                                                                                                this.borrarRegistros(IdItem)
                                                                                            }
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faTrashAlt} /> Eliminar
                                                                                        </button>
                                                    </td>
                                                    
                                                  
                                                   {/*  <button
                                                                                            type="button"
                                                                                            className="btn btn-info btn-sm"
                                                                                            onClick={() =>
                                                                                                this.ImprimirRegistros(IdItem)
                                                                                            }
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faPrint} /> Imprimir
                                                                                        </button> */}
                                                   
                                                </tr>:
                                                <tr>
                                                    <td colSpan={5}></td>
                                                    <td>
                                                    <button
                                                                                            type="button"
                                                                                            className="btn btn-info btn-sm"
                                                                                            onClick={() =>
                                                                                                this.ImprimirRegistros(IdItem)
                                                                                            }
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faPrint} /> Imprimir
                                                                                        </button>
                                                    </td>
                                                </tr>
                                                }

                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="UCAPModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="UCAPModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="UCAPModalLabel">Formato de Cotizacion AGM</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              
                                <PDFViewer style={{width:"100%",height:"90vh"}}>
                                    {CargandoMat==1?<PDF ite={cotizaciones}  />:''}
                                </PDFViewer>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PModalLabel">Productos + </h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-2">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bcodigoProducto" name="bcodigoProducto" placeholder="Codigo" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-2">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bnombreProducto" name="bnombreProducto" placeholder="Nonbre Producto" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-2">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bnombrecat" name="bnombrecat" placeholder="Buscar x categoria" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-2">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bnombremunicipio" name="bnombremunicipio" placeholder="Municipio" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-2">
                                <select  className="form-select form-select-sm" name="global" id="global">
                                    <option value="0">Material Global</option>
                                    <option value="1">Material Historico</option>
                                </select>
                                </div>
                                    <div className="col-xl-2">
                                        <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.cargarProductos(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                    </div>
                                    {
                                        BOTONES==1?
                                        <div className="col-xl-2">
                                           <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.AgregarMasivoMunicipio()}><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Agregar todo el municipio</button>
                                        </div>:''
                                    }
                                </div>
                                <br></br>
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CÓDIGO</th>
                                                    <th className="align-middle">PRODUCTO</th>
                                                    <th className="align-middle">UNIDAD</th>
                                                    <th className="align-middle">CATEGORIA</th>
                                                    <th className="align-middle">MUNICIPIO</th>
                                                    <th className="align-middle">TIPO</th>
                                                    <th className="align-middle">DIGITE CANT.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {load}
                                                {
                                                    productos.map((itemProductos) => (
                                                        <tr key={itemProductos.ID_PRODUCTO}>
                                                            <td>{itemProductos.CODIGO}</td>
                                                            <td>{itemProductos.PRODUCTO} <br/>{itemProductos.FECHA_ACTUALIZACION}</td>
                                                            {
                                                                (() => {
                                                                    switch (itemProductos.ID_TIPO_UNIDAD) {
                                                                        case 1:
                                                                            return (<td>GLB</td>)
                                                                        case 2:
                                                                            return (<td>M</td>)
                                                                        case 3:
                                                                            return (<td>ROLLO</td>)
                                                                        case 4:
                                                                            return (<td>UND</td>)
                                                                    }
                                                                })()
                                                            }
                                                            <td>{itemProductos.NOMBRE}</td>
                                                            <td>{itemProductos.MUNICIPIO_RELACIONADO}</td>
                                                            <td>
                                                                <select className='form-control form-select' id={'tipo_' + itemProductos.ID_PRODUCTO}
                                                                        name={'tipo_' + itemProductos.ID_PRODUCTO}>
                                                                    <option value='CA' title='Cantidad Actual'>Cant.Actual</option>
                                                                    <option value='CI' title='Cantidad de Inversion'>Cant.Inv</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <input className={((this.verificarError("error_cantidad_producto_" + itemProductos.ID_PRODUCTO)) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                                        type="text" id={'cantidadProducto_' + itemProductos.ID_PRODUCTO}
                                                                        name={'cantidadProducto_' + itemProductos.ID_PRODUCTO}
                                                                        
                                                                        aria-describedby="helpId" />&nbsp;&nbsp;
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        disabled={this.state.disabledEditarButton === false ? '' : true}
                                                                        onClick={() =>
                                                                            this.agregarProducto(itemProductos.ID_PRODUCTO)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarProductos(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarProductos(actualProductos - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                {(() => {
                                                    let p = [];
                                                    p.push(<li className="page-item" key={actualProductos}><a className="page-link" href="#" onClick={() => this.cargarProductos(actualProductos)}>{actualProductos}</a></li>);
                                                    return p;
                                                })()}
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarProductos(actualProductos + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarProductos(ultimoProductos)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                            <div className='modal-footer'>
                                <b>Pagina</b> <span className="badge bg-primary">{actualProductos}</span> <b>de</b> <span className="badge bg-primary">{ultimoProductos}</span> | <b>Registros</b> <span className="badge bg-success">{paginaProductos}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="PModal2" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PModal2Label" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PModalLabel">Productos Relacionados con el municipio <button id="bt" name="bt" className="btn btn-success btn-sm" onClick={() => this.CargarModelo()}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Agregar Modelo anterior</button></h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-3">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bnombreProducto2" name="bnombreProducto2" placeholder="Producto" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-3">
                                        <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.cargarProductos2(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                    </div>
                                </div>
                                <br></br>
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">CÓDIGO</th>
                                                    <th className="align-middle">PRODUCTO</th>
                                                    <th className="align-middle">UNIDAD</th>
                                                    <th className="align-middle">CAPITULO</th>
                                                    <th className="align-middle">DIGITE CANT.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {load}
                                                {
                                                    productos2.map((itemProductos) => (
                                                        <tr key={itemProductos.ID_PRODUCTO}>
                                                            <td>{itemProductos.CODIGO}</td>
                                                            <td>{itemProductos.PRODUCTO}</td>
                                                            {
                                                                (() => {
                                                                    switch (itemProductos.ID_TIPO_UNIDAD) {
                                                                        case 1:
                                                                            return (<td>GLB</td>)
                                                                        case 2:
                                                                            return (<td>M</td>)
                                                                        case 3:
                                                                            return (<td>ROLLO</td>)
                                                                        case 4:
                                                                            return (<td>UND</td>)
                                                                    }
                                                                })()
                                                            }
                                                            <td>{itemProductos.NOMBRE}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <input className={((this.verificarError("error_cantidad_producto_" + itemProductos.ID_PRODUCTO)) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                                        type="text" id={'cantidadProducto_' + itemProductos.ID_PRODUCTO}
                                                                        name={'cantidadProducto_' + itemProductos.ID_PRODUCTO}
                                                                        aria-describedby="helpId" />&nbsp;&nbsp;
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        disabled={this.state.disabledEditarButton === false ? '' : true}
                                                                        onClick={() =>
                                                                            this.agregarProducto(itemProductos.ID_PRODUCTO)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarProductos2(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarProductos2(actualProductos2 - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                {(() => {
                                                    let p = [];
                                                    p.push(<li className="page-item" key={actualProductos2}><a className="page-link" href="#" onClick={() => this.cargarProductos2(actualProductos2)}>{actualProductos2}</a></li>);
                                                    return p;
                                                })()}
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarProductos2(actualProductos2 + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarProductos(ultimoProductos2)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                            <div className='modal-footer'>
                                <b>Pagina</b> <span className="badge bg-primary">{actualProductos2}</span> <b>de</b> <span className="badge bg-primary">{ultimoProductos2}</span> | <b>Registros</b> <span className="badge bg-success">{paginaProductos2}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        );
    }
}

export default Editar;